import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=88ba23c6&"
import script from "./RichEditor.vue?vue&type=script&lang=js&"
export * from "./RichEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports